<template>
  <div>
    <div
      class="innerBox"
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 7.5px 10px;
      "
    >
      <button
        class="btn"
        style="font-size: 16px; color: #6c6c6c; font-weight: bold; padding: 4px"
        @click="$router.go(-1)"
      >
        <i class="fas fa-angle-left mr-2"></i>Back
      </button>
      <p class="mb-0" style="font-size: 16px; color: #b9b9b9; font-weight: 600">
        | Pengecekan Truck >> View Detail <i class="fas fa-angle-right"></i>
      </p>
      <p
        class="mb-0 ml-1"
        style="font-size: 16px; color: #4b4b4b; font-weight: bold"
      >
        {{ nopol }}
      </p>
    </div>
    <div class="innerBox mt-4">
      <div class="col">
        <div class="row">
          <div class="col-10" style="font-size: 16px; font-weight: 600">
            Data checking
          </div>
          <div class="col-2" style="font-size: 16px; font-weight: 600">
            Score : {{ point }}
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-4" v-for="(column, columnIndex) in 3" :key="columnIndex">
            <div
              v-for="(val, i) in dataDetails.slice(columnIndex * columnSize, (columnIndex + 1) * columnSize)"
              :key="i"
              class="row mt-3"
            >
              <div class="col mt-2">
                <label>{{ val.name }}</label>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col-3 mt-2">
                    <span
                      ><svg
                        v-if="val.user_answer === val.answer_true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                      >
                        <g
                          id="Group_2002"
                          data-name="Group 2002"
                          transform="translate(-115 -298)"
                        >
                          <circle
                            id="Ellipse_20"
                            data-name="Ellipse 20"
                            cx="8.5"
                            cy="8.5"
                            r="8.5"
                            transform="translate(115 298)"
                            fill="#05e205"
                          />
                          <path
                            id="Path_33"
                            data-name="Path 33"
                            d="M383.135,39.213l2.475,2.475,5.134-5.134"
                            transform="translate(-262.934 267.912)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="3"
                          />
                        </g>
                      </svg>
                      <svg
                        v-if="val.user_answer === val.answer_false"
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                      >
                        <g
                          id="Group_1919"
                          data-name="Group 1919"
                          transform="translate(-115 -298)"
                        >
                          <circle
                            id="Ellipse_20"
                            data-name="Ellipse 20"
                            cx="8.5"
                            cy="8.5"
                            r="8.5"
                            transform="translate(115 298)"
                            fill="#ec1b30"
                          />
                          <g id="Group_1872" data-name="Group 1872">
                            <path
                              id="Path_33"
                              data-name="Path 33"
                              d="M385.61,41.688l5.134-5.134"
                              transform="translate(-264.677 267.912)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="3"
                            />
                            <path
                              id="Path_2661"
                              data-name="Path 2661"
                              d="M390.744,41.688l-5.134-5.134"
                              transform="translate(-264.677 267.912)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="3"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                  </div>
                  <div
                    v-if="val.user_answer === val.answer_false"
                  >
                  <a v-if="val.is_photo" :href="val.photo_url" target="_blank" class="btn btn-outline-secondary"><svg xmlns="http://www.w3.org/2000/svg" width="9.954" height="9.954" viewBox="0 0 9.954 9.954">
  <path id="Icon_material-photo" data-name="Icon material-photo" d="M14.454,13.348V5.606A1.109,1.109,0,0,0,13.348,4.5H5.606A1.109,1.109,0,0,0,4.5,5.606v7.742a1.109,1.109,0,0,0,1.106,1.106h7.742A1.109,1.109,0,0,0,14.454,13.348ZM7.541,10.306l1.382,1.665,1.935-2.494,2.488,3.318H5.606Z" transform="translate(-4.5 -4.5)" fill="#a2a2a2"/>
</svg>
Lihat Foto</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <p class="ml-1">Notes : {{ notes }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    console.log('ini pengecekan truck data', this.$store.state.pengecekanTruckData);
    const pengecekanTruckData = JSON.parse(
      this.$store.state.pengecekanTruckData
    );
    this.getTruckDetail(pengecekanTruckData.id);
  },
  data() {
    return {
      columnSize: 0,
      dataDetails: null,
      nopol: JSON.parse(this.$store.state.pengecekanTruckData).nopol,
      point: JSON.parse(this.$store.state.pengecekanTruckData).all_point,
      notes: JSON.parse(this.$store.state.pengecekanTruckData).notes
    };
  },
  methods: {
    getTruckDetail(id) {
      this.$http
        .get(`/api/validation/pengecekan-truk/detail/${id}`)
        .then((resp) => {
          this.dataDetails = resp.data.data;
          this.columnSize = Math.ceil(resp.data.data.length / 3);
        });
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}
</style>
